module.exports = __webpack_public_path__ + "static/media/serena_mobile.6cd2b3dd.jpg";